import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f54e108")

_pushScopeId("data-v-7f54e108")
const _hoisted_1 = { class: "header flexbox-row padding-top-40 padding-bottom-40" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "material-icons color-blue cursor-pointer margin-right-10" }, "keyboard_arrow_left", -1)
const _hoisted_3 = { class: "go-back-text color-blue uppercase" }
const _hoisted_4 = { class: "p-grid padding-bottom-20" }
const _hoisted_5 = { class: "p-col-12 p-text-left" }
const _hoisted_6 = { class: "title margin-bottom-0" }
const _hoisted_7 = { class: "p-text-uppercase" }
const _hoisted_8 = { class: "registry-container" }
const _hoisted_9 = { class: "centered" }
const _hoisted_10 = { class: "registry-row" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = { class: "value" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "label" }, /*#__PURE__*/_toDisplayString('Email'), -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "label" }
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "label" }
const _hoisted_24 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_25 = { class: "value" }
const _hoisted_26 = { class: "label" }
const _hoisted_27 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_28 = { class: "value" }
const _hoisted_29 = { class: "p-text-uppercase" }
const _hoisted_30 = { class: "p-d-flex p-jc-end margin-bottom-20" }
const _hoisted_31 = { class: "button-text" }
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "material-icons color-blue" }, "add", -1)
const _hoisted_33 = { class: "cards-container margin-top-20 margin-bottom-10" }
const _hoisted_34 = { class: "p-text-uppercase" }
const _hoisted_35 = { class: "modal-content p-text-center p-p-6" }
const _hoisted_36 = /*#__PURE__*/_createVNode("i", {
  class: "pi pi-exclamation-triangle color-warning",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_37 = { class: "p-d-flex p-jc-end" }
_popScopeId()

import { useStore } from "@/store/store";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import {
  computed,
  onMounted,
  ref,
  watch,
} from "vue";
import { PadelClub } from "@/models/club.models";
import { ActionTypes } from "@/store/action-types";
import { MutationTypes } from "@/store/mutation-types";
import Avatar from "@/components/avatar/Avatar.vue";
import UserCard from "@/components/user-card/UserCard.vue";
import UserScheduledTable from "@/components/user-scheduled-table/UserScheduledTable.vue";
import { User } from "@/generated-sources/anagrafica-api";
import { formatDateDDMMYYYY } from "@/services/dates.service";


export default _defineComponent({
  setup(__props) {

/* eslint-disable */
const { t, locale } = useI18n();
const route = useRoute();
const store = useStore();
const router = useRouter();
const cards = ref(null);
const showConfirmDialog = ref(false);
const selectedCard = ref(null);
const user = ref<User>();

// TABS
const selectedTab = ref(0);

/* COMPUTED */
const myClub = computed(function (): PadelClub {
  return store.getters.getMyClub;
});

// LIFECYCLE
onMounted(() => {
  if (!route.params.id) {
    router.replace({ name: "Users" });
    return;
  }
  loadUserData();
});

// FUNCTIONS
async function loadUserData() {
  try {
    const request = await store.dispatch(ActionTypes.GET_USER_BY_ID, {
      userId: route.params.id as string,
    });
    user.value = request.user;

    // ---
    store.commit(MutationTypes.SET_SEARCH_USER, { ...user.value });

    // SELECT
    selectTab();
  } catch (e) {
    throw e;
  }
}

function selectTab() {
  if (route.query.tab) {
    if (route.query.tab === "cards") {
      selectedTab.value = 1;
    }

    // CLEAR QUERY
    setTimeout(() => {
      const query = Object.assign({}, route.query);
      delete query.tab;
      router.replace({ query });
    }, 100);
  }
}

function onChangeTab(event) {
  selectedTab.value = event;
}

function createCard() {
  // SET
  store.commit(MutationTypes.SET_USER_CARDS, cards.value);

  // PUSH
  router.push({ name: "create-card", params: { id: user.value.id } });
}

function getCards() {
  store
    .dispatch(ActionTypes.GET_CARDS, { user_id: user.value.id, limit: 20 })
    .then((response) => {
      cards.value = response.data.records;
    });
}

function onClickEvent(event: any) {
  const item = JSON.parse(JSON.stringify(event));
  store.commit(MutationTypes.SET_SCROLL_EVENT, item);
  setTimeout(() => {
    router.push({ name: "Scheduler" });
  }, 100);
}

function onEditCard(card) {
  router.push({ name: "edit-card", params: { card_id: card.id } });
}

function onDeleteCard(card) {
  selectedCard.value = card;
  showConfirmDialog.value = true;
}

function onDelete(id) {
  store.dispatch(ActionTypes.DELETE_CARD, { id: id }).then(() => {
    hideDialog();
    getCards();
  });
}

function onRenewCard(card) {
  // SET
  store.commit(MutationTypes.SET_USER_CARDS, cards.value);

  // PUSH
  router.push({
    name: "create-card",
    params: { id: user.value.id },
    query: { renew_id: card.id },
  });
}

function hideDialog() {
  selectedCard.value = null;
  showConfirmDialog.value = false;
}
/** WATCH */
watch(selectedTab, function () {
  if (selectedTab.value == 1) {
    if (cards.value == null) getCards();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_PadelButton = _resolveComponent("PadelButton")!
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (user.value)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", {
              class: "cursor-pointer flexbox-row align-center",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).go(-1)))
            }, [
              _hoisted_2,
              _createVNode("div", _hoisted_3, _toDisplayString(_unref(t)('back')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("h3", _hoisted_6, _toDisplayString(`${user.value.nome} ${user.value.cognome}`), 1)
            ])
          ]),
          _createVNode(_component_TabView, {
            class: "tab-view p-mb-5",
            activeIndex: selectedTab.value,
            onTabChange: _cache[3] || (_cache[3] = ($event: any) => (onChangeTab($event.index)))
          }, {
            default: _withId(() => [
              _createVNode(_component_TabPanel, null, {
                header: _withId(() => [
                  _createVNode("i", {
                    class: ["material-icons", { 'color-blue': selectedTab.value === 0 }]
                  }, "person", 2),
                  _createVNode("span", _hoisted_7, _toDisplayString(_unref(t)('registry')), 1)
                ]),
                default: _withId(() => [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(Avatar, {
                        photo: user.value.urlFoto
                      }, null, 8, ["photo"])
                    ]),
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", null, [
                        _createVNode("span", _hoisted_11, _toDisplayString(_unref(t)('birthdate')), 1),
                        _hoisted_12,
                        _createVNode("span", _hoisted_13, _toDisplayString(_unref(formatDateDDMMYYYY)(user.value.dataDiNascita) || '-'), 1)
                      ]),
                      _createVNode("div", null, [
                        _hoisted_14,
                        _hoisted_15,
                        _createVNode("span", _hoisted_16, _toDisplayString(user.value.email), 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("span", _hoisted_17, _toDisplayString(_unref(t)('phonenumber')), 1),
                        _hoisted_18,
                        _createVNode("span", _hoisted_19, _toDisplayString(user.value.cell), 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("span", _hoisted_20, _toDisplayString(_unref(t)('gender')), 1),
                        _hoisted_21,
                        _createVNode("span", _hoisted_22, _toDisplayString(user.value.gender), 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("span", _hoisted_23, _toDisplayString(_unref(t)('privacy_consents')), 1),
                        _hoisted_24,
                        _createVNode("span", _hoisted_25, _toDisplayString(user.value.marketingGG ? _unref(t)("yes") : _unref(t)("no")), 1)
                      ]),
                      _createVNode("div", null, [
                        _createVNode("span", _hoisted_26, _toDisplayString(_unref(t)('partner_communication_consents')), 1),
                        _hoisted_27,
                        _createVNode("span", _hoisted_28, _toDisplayString(_unref(t)(user.value.marketingTerzeParti ? "yes" : "no")), 1)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                header: _withId(() => [
                  _createVNode("i", {
                    class: ["material-icons", { 'color-blue': selectedTab.value === 1 }]
                  }, "recent_actors", 2),
                  _createVNode("span", _hoisted_29, _toDisplayString(_unref(t)('cards')), 1)
                ]),
                default: _withId(() => [
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_30, [
                      _createVNode("div", {
                        class: "cursor-pointer flexbox-row align-center p-mt-md-3",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (createCard()))
                      }, [
                        _createVNode("span", _hoisted_31, _toDisplayString(_unref(t)('add_new_card')), 1),
                        _hoisted_32
                      ])
                    ]),
                    _createVNode("div", _hoisted_33, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(cards.value, (element, index) => {
                        return (_openBlock(), _createBlock(UserCard, {
                          key: index,
                          element: element,
                          user: user.value,
                          index: index,
                          onEditCard: onEditCard,
                          onDeleteCard: onDeleteCard,
                          onRenewCard: onRenewCard
                        }, null, 8, ["element", "user", "index"]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, null, {
                header: _withId(() => [
                  _createVNode("i", {
                    class: ["material-icons", { 'color-blue': selectedTab.value === 2 }]
                  }, "list", 2),
                  _createVNode("span", _hoisted_34, _toDisplayString(_unref(t)('scheduled')), 1)
                ]),
                default: _withId(() => [
                  _createVNode("div", null, [
                    _createVNode(UserScheduledTable, {
                      user: user.value,
                      onOnClick: onClickEvent
                    }, null, 8, ["user"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeIndex"])
        ], 64))
      : _createCommentVNode("", true),
    (showConfirmDialog.value)
      ? (_openBlock(), _createBlock(_component_DumbModal, {
          key: 1,
          title: _unref(t)('deleting_card'),
          onHide: _cache[5] || (_cache[5] = ($event: any) => (hideDialog()))
        }, {
          footer: _withId(() => [
            _createVNode("div", _hoisted_37, [
              _createVNode(_component_PadelButton, {
                label: _unref(t)('confirm'),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (onDelete(selectedCard.value.id)))
              }, null, 8, ["label"])
            ])
          ]),
          default: _withId(() => [
            _createVNode("div", _hoisted_35, [
              _hoisted_36,
              _createVNode("p", {
                class: "p-text-center color-white",
                innerHTML: _unref(t)('deleting_card_message', { card: selectedCard.value.card_code })
              }, null, 8, ["innerHTML"])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})